import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import { 
  REQUEST_EXPERIENCE_LIST,
  REQUEST_EXPERIENCE_SEARCH_REQUEST_LIST,
  REQUEST_EXPERIENCE_SEARCH_GEO_COUNTRY_LIST,
  REQUEST_EXPERIENCE_ADD,
  REQUEST_EXPERIENCE_DETAIL,
  REQUEST_EXPERIENCE_UPDATE,
} from '../actions';
import {
  RequestExperienceListSuccess,
  RequestExperienceListError,
  RequestExperienceSearchRequestListSuccess,
  RequestExperienceSearchRequestListError,
  RequestExperienceSearchGeoCountryListSuccess,
  RequestExperienceSearchGeoCountryListError,
  RequestExperienceAddSuccess,
  RequestExperienceAddError,
  RequestExperienceDetailSuccess,
  RequestExperienceDetailError,
  RequestExperienceUpdateSuccess,
  RequestExperienceUpdateError
} from '../actions';
 
export function* watchRequestExperienceList() {
  yield takeEvery(REQUEST_EXPERIENCE_LIST, onRequestExperienceList);
}

export function* watchRequestExperienceSearchRequestList() {
  yield takeEvery(REQUEST_EXPERIENCE_SEARCH_REQUEST_LIST, onRequestExperienceSearchRequestList);
}

export function* watchRequestExperienceSearchGeoCountryList() {
  yield takeEvery(REQUEST_EXPERIENCE_SEARCH_GEO_COUNTRY_LIST, onRequestExperienceSearchGeoCountryList);
}

export function* watchRequestExperienceAdd() {
  yield takeEvery(REQUEST_EXPERIENCE_ADD, onRequestExperienceAdd);
}

export function* watchRequestExperienceDetail() {
  yield takeEvery(REQUEST_EXPERIENCE_DETAIL, onRequestExperienceDetail);
}

export function* watchRequestExperienceUpdate() {
  yield takeEvery(REQUEST_EXPERIENCE_UPDATE, onRequestExperienceUpdate);
}

const onRequestExperienceListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_experience/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onRequestExperienceUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_experience/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onRequestExperienceSearchRequestListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/request', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestExperienceSearchGeoCountryListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/geo_country', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const onRequestExperienceAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_experience/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onRequestExperienceDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'request_experience/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onRequestExperienceList(data) {
  try {
    const response = yield call(onRequestExperienceListAsync, data.payload);
    yield put(RequestExperienceListSuccess(response.data));
  } catch (error) {
    yield put(RequestExperienceListError(error));
  }
}

function* onRequestExperienceSearchRequestList(data) {
  try {
    console.log('onRequestExperienceSearchRequestList',data.payload)
    const response = yield call(onRequestExperienceSearchRequestListAsync, data.payload);
    yield put(RequestExperienceSearchRequestListSuccess(response.data));
  } catch (error) {
    yield put(RequestExperienceSearchRequestListError(error));
  }
}

function* onRequestExperienceSearchGeoCountryList(data) {
  try {
    const response = yield call(onRequestExperienceSearchGeoCountryListAsync, data.payload);
    yield put(RequestExperienceSearchGeoCountryListSuccess(response.data));
  } catch (error) {
    yield put(RequestExperienceSearchGeoCountryListError(error));
  }
}

function* onRequestExperienceAdd(data) {
  try {
      const response = yield call(onRequestExperienceAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestExperienceAddSuccess(response.data));
  } catch (error) {
      yield put(RequestExperienceAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onRequestExperienceDetail(data) {
  try {
    const response = yield call(onRequestExperienceDetailAsync, data.payload);
    yield put(RequestExperienceDetailSuccess(response.data.data));
  } catch (error) {
    yield put(RequestExperienceDetailError(error));
  }
}

function* onRequestExperienceUpdate(data) {
  try {
      const response = yield call(onRequestExperienceUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(RequestExperienceUpdateSuccess(response.data));
  } catch (error) {
      yield put(RequestExperienceUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchRequestExperienceList),
    fork(watchRequestExperienceSearchRequestList),
    fork(watchRequestExperienceSearchGeoCountryList),
    fork(watchRequestExperienceAdd),
    fork(watchRequestExperienceDetail),
    fork(watchRequestExperienceUpdate),
  ]);
} 